import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'assessmentReport',
    label: 'Assessment Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
